<template>


  <div class="children-container">
    <div class="children-module-name"><span>地址管理</span></div>
    <div class="children-module-info">
      <div>
        <a-button style="margin-bottom: 20px;border-radius: 0px 16px 0px 16px;" type="primary" @click="openModal" icon="plus">添加
        </a-button>
      </div>
      <div class="list" v-for="(item, index) in list" :key="index">
        <div class="info">
          <div><span class="label">联系人:</span><span class="name">{{item.name}}{{item.mobile}}</span><span
              v-if="item.is_default == 'TRUE'" class="default">默认地址</span></div>
          <div><span class="label">收货地址:</span><span
              class="name">{{item.province}}{{item.city}}{{item.area}}{{item.info}}</span></div>
        </div>
        <div class="action">
          <a-button type="link" @click="setDefault(item.id)" v-if="item.is_default == 'FALSE'" icon="edit">设为默认地址
          </a-button>
          <a-button type="link" @click="openEditModal(item.id)" icon="edit">编辑</a-button>
          <span style="border-right:1px solid #ddd;height: 10px;"></span>
          <a-button type="link" @click="openDelete(item.id)" style="color: #666;" icon="delete">删除</a-button>
        </div>
      </div>
      <div v-if="list.length == 0 && page.flag == true"
            style="display: flex;justify-content: center;margin-top: 10%;">
            <a-empty description="暂无地址数据" />
          </div>
      <div class="page-container">
        <a-pagination :hideOnSinglePage="true" :page-size.sync="page.pageSize" :total="page.totalRow" v-model="page.start"
          @change="changePage" />
      </div>
      <a-modal dialogClass="custom-dialog" :maskClosable="false" v-model="modalVisible" title="地址管理" @ok="actionData" :width="650" :destroyOnClose="true"
        :disabled="$store.state.requestLoading">
        <a-form-model style="padding-left: 80px;" ref="formModel" :rules="formModelRules" :model="formModel"
          layout="vertical" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
          <a-form-model-item label="姓名" prop="name">
            <a-input placeholder="请输入姓名" v-model="formModel.name"></a-input>
          </a-form-model-item>
          <a-form-model-item label="手机号" prop="mobile">
            <a-input placeholder="请输入手机号" v-model="formModel.mobile"></a-input>
          </a-form-model-item>
          <a-form-model-item label="地区" prop="area_id">
            <address-select :type.sync="formModel.id ? 'edit' : 'add'" :ids="{pid: formModel.province_id, cid: formModel.city_id, aid: formModel.area_id}" @addressSelect="addressSelect" />
          </a-form-model-item>
          <a-form-model-item label="详细地址" prop="info">
<!--            <a-textarea placeholder="XX省xx市xx区xx路xx号" v-model="formModel.info" :auto-size="{ minRows: 4, maxRows: 4 }"></a-textarea>-->
            <a-select
                show-search
                allowClear
                :value="formModel.info"
                placeholder="请输入或搜索详细地址"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @blur="searchBlur"
                @search="detailAddressSearch"
                @change="detailAddressChange"
                @select="detailAddressSelect"
            >
              <a-select-option v-for="(item, index) in searchDetailList" :key="index">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="默认地址" prop="is_default">
            <a-radio-group style="padding-top: 8px;" v-model="formModel.is_default">
              <a-radio value="TRUE">
                是
              </a-radio>
              <a-radio value="FALSE">
                否
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<script>
  import * as Api from './api';
  import * as commonApi from '@/commonApi';
  import {FuzzyMatching} from "./api";

  export default {
    data() {
      let validateMobile = (rule, value, callback) => {
        if (!commonApi.MobileReg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        }
        callback();
      };
      return {
        formModel: {
          name: '',
          area_id: '',
          province_id: '',
          mobile: '',
          city_id: '',
          info: undefined,
          is_default: 'TRUE',
          is_crm: 'FALSE'
        },
        modalVisible: false,
        formModelRules: {
          name: [{ required: true, message: '请输入姓名', trigger: 'change' }],
          mobile: [{ required: true, message: '请输入手机号', trigger: 'change' }, { validator: validateMobile, trigger: 'change' }],
          area_id: [{ required: true, message: '请选择地区', trigger: 'change' }],
          info: [{ required: true, message: '请输入详情地址', trigger: 'blur' }],
          is_default: [{ required: true, message: '请选择是否为默认地址', trigger: 'change' }]
        },
        list: [],
        page: {
          start: 1,
          limit: 20,
          pageSize: 0,
          totalRow: 0,
          flag: false
        },
        timeout: null,
        currentValue: '',
        searchDetailList: []
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      searchBlur(e) {
        this.formModel.info = e;
      },
      detailAddressSearch(e) {
        this.formModel.info = e;
        this.formModel.is_crm = 'FALSE'
        this.getSearchKey();
      },

      getSearchKey() {
        if(this.timeout) {
          clearTimeout(this.timeout);
          this.timeout = null;
        }
        this.timeout = setTimeout(this.search, 1000);
      },

      async search() {
        let res = await Api.FuzzyMatching({ address: this.formModel.info });
        if (res && res.code == 0) {
          this.searchDetailList = res.list;
        }
      },

      detailAddressChange(e) {
        console.log(e)
        if (e == undefined) {
          this.formModel.info = undefined;
          this.searchDetailList = [];
        } else {
          this.formModel.info = e;
        }
      },
      detailAddressSelect(e) {
        this.formModel.info = this.searchDetailList[e];
        this.formModel.is_crm = 'TRUE';
      },

      // 重置表单数据
      resetFormModel() {
        this.formModel.id = '';
        this.formModel.name = '';
        this.formModel.mobile = '';
        this.formModel.info = undefined;
        this.formModel.province_id = undefined;
        this.formModel.city_id = undefined;
        this.formModel.area_id = undefined;
        this.formModel.is_default = 'TRUE';
        this.formModel.is_crm = 'FALSE';
      },

      // 地址选择
      addressSelect(data) {
        this.formModel.province_id = data.province_id;
        this.formModel.city_id = data.city_id;
        this.formModel.area_id = data.area_id;
        this.$refs.formModel.validateField('area_id')
      },

      // 打开添加框
      openModal() {
        this.resetFormModel();
        this.modalVisible = true;
      },

      // 打开编辑框
      async openEditModal(id) {
        this.resetFormModel();
        let res = await Api.Detail({ id: id });
        if (res && res.code == 0) {
          this.formModel = res.target;
          this.modalVisible = true;
        }
      },

      // 获取列表
      async getList() {
        let res = await Api.GetList(this.page);
        if (res && res["code"] == "0") {
          this.page.totalRow = res.page.totalRow;
          this.page.pageSize = res.page.pageSize;
          this.list = res.page.list;
          this.page.flag = true;
        }
      },
      // 添加/编辑
      async actionData() {
        this.$refs.formModel.validate(async valid => {
          if (valid) {
            let res = null;
            if (this.formModel.id) {
              res = await Api.Edit(this.formModel);
            } else {
              res = await Api.Save(this.formModel);
            }

            if (res && res.code == 0) {
              this.modalVisible = false;
              this.$message.success(res.message);
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          }
        });
      },
      // 删除
      openDelete(id) {
        let that = this;
        this.$confirm({
          title: "信息提示",
          okType: "danger",
          content: "您确定要删除吗",
          okText: "确定",
          cancelText: "取消",
          async onOk() {
            let res = await Api.Delete({ id: id });
            if (res && res["code"] == "0") {
              that.getList();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          },
          onCancel() {
          },
        });
      },

      // 设为默认地址
      async setDefault(id) {
        let res = await Api.SetDefault({ id: id });
        if (res && res.code == 0) {
          this.$message.success(res.message);
          this.getList();
        } else {
          this.$message.error(res.message);
        }
    },

    // 改变分页
    changePage(e) {
      this.page.start = currentPage;
      this.getList();
    }
  },
  };
</script>

<style lang="less">
  .tips-text {
    font-size: 14px;
    font-weight: 500;
    color: #007F76;
    line-height: 38px;
    padding-top: 2px;
  }

  .children-module-content {
    padding: 25px !important;
    background-color: #fff !important;
  }

  .list {
    border: 1px solid #ECECEC;
    padding: 30px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .list .label {
    font-size: 12px;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
    margin-right: 10px;
  }

  .list .info {
    flex: 1;
  }

  .list .action {
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: flex-end
  }

  .list .default {
    font-size: 12px;
    font-weight: 500;
    text-decoration: underline;
    color: #008276;
    line-height: 30px;
    margin-left: 10px;
  }

  .list .name {
    font-size: 12px;
    color: #999999;
    line-height: 30px;
  }
</style>